<template>
  <div class="w-full flex flex-col items-center">
    <!-- Main Container -->
    <div class="flex flex-col md:flex-row gap-6 w-full">
      <!-- Left: Transaction Data -->
      <div class="w-1/2">
        <h2 class="font-semibold text-gray-700 mb-4">TRANSACTION DATA</h2>
        <div class="border border-gray-200 bg-white rounded-lg shadow p-4">
          <div class="divide-y divide-gray-300">
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Account to Debit</span>
              <span class="text-gray-800 text-right">
                {{ transactionData.account?.account_name }} - {{ transactionData.account?.account_number }} ({{ transactionData.account?.currency }})
              </span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">IBAN</span>
              <span class="text-gray-800 text-right">{{ transactionData.iban }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">BIC / SWIFT Code</span>
              <span class="text-gray-800 text-right">{{ transactionData.swift }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Beneficiary name</span>
              <span class="text-gray-800 text-right">{{ transactionData.beneficiaryName }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Value</span>
              <span class="text-gray-800 text-right">EUR {{ transactionData.value }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Description</span>
              <span class="text-gray-800 text-right">{{ transactionData.description }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Additional Information</span>
              <span class="text-gray-800 text-right">{{ transactionData.additionalInfo }}</span>
            </div>
            <div class="flex justify-between p-2">
              <span class="text-gray-500">Nature of Fund Transfer</span>
              <span class="text-gray-800 text-right">{{ transactionData.transferNature }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right: Operation Confirmation -->
      <div class="w-1/2 flex flex-col h-fit gap-y-2 bg-white border border-orange-300 text-sm text-gray-700 p-4 rounded-lg mb-8 shadow">
        <div class="flex items-center gap-2">
          <component :is="Info" class="w-5 h-5 text-primary"/>
          <p class="text-gray-800 font-semibold">YOUR REQUEST WAS REGISTERED (ID: {{ transactionId || 'Pending' }})</p>
        </div>

        <div class="flex justify-center">
          <span>Processing...</span>
        </div>
      </div>
    </div>

    <!-- Go Back / New Transfer Buttons -->
    <div class="flex flex-col md:flex-row w-full justify-center mt-6 gap-4">
      <button  @click="downloadPDF"
          class="w-full md:w-1/4 px-8 py-3 text-primary rounded-md bg-white font-semibold transition shadow"
      >
        Download PDF
      </button>
      <button
          @click="closePanel"
          class="w-full md:w-1/4 px-8 py-3 rounded-md text-white bg-primary font-semibold transition shadow"
      >
        NEW TRANSFER
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { Info } from 'lucide-vue-next';
import jsPDF from 'jspdf';


const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  transactionData: {
    type: Object,
    default: () => ({})
  },
  transactionId: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue']);

const closePanel = () => {
  emit('update:modelValue', false);
}


const downloadPDF = () => {
  const doc = new jsPDF();
  doc.setFontSize(12);
  doc.text('Transaction Confirmation', 10, 10);
  doc.text(`Transaction ID: ${props.transactionId || 'Pending'}`, 10, 20);
  doc.text(`Account: ${props.transactionData.account?.account_name} - ${props.transactionData.account?.account_number} (${props.transactionData.account?.currency})`, 10, 30);
  doc.text(`IBAN: ${props.transactionData.iban}`, 10, 40);
  doc.text(`SWIFT: ${props.transactionData.swift}`, 10, 50);
  doc.text(`Beneficiary: ${props.transactionData.beneficiaryName}`, 10, 60);
  doc.text(`Value: ${props.transactionData.value} EUR`, 10, 70);
  doc.text(`Description: ${props.transactionData.description}`, 10, 80);
  doc.text(`Additional Info: ${props.transactionData.additionalInfo}`, 10, 90);
  doc.text(`Transfer Nature: ${props.transactionData.transferNature}`, 10, 100);

  doc.save(`transaction_${props.transactionId || 'pending'}.pdf`);
}


</script>

<style scoped>
.h-fit {
  height: fit-content;
}
</style>
